import AdvertisingSection from './advertising-section';

export default AdvertisingSection;
